<template>
  <div class="common-box margin-t10">
    <el-row class="row-one">
      <span class="row-one-title">基金组合卖出</span>
      <span class="row-one-subTitle">{{message.funddesc}}</span>
      <Reback class="row-one-fr" @click.native="returnClick"></Reback>
    </el-row>
    <!-- 表单 -->
    <el-form v-show="stepDisplay == '1'" :model="combinationSellForm" :rules="tcombinationSellFormRules" ref="tcombinationSellFormRef" label-width="93px" class="form-single">
      <el-form-item label="赎回金额：">
        <span class="aColor">(仅支持全部赎回)</span>
      </el-form-item>
      <el-form-item label="收款方式：" prop="card">
        <BankCardList v-model="combinationSellForm.card" @slected="getslectedValue" @func="slectedValue"></BankCardList>
      </el-form-item>
      <el-form-item label="密码：" prop="pass" :error="errorMsg">
        <el-input class="inputThree" type="password" v-model="combinationSellForm.pass" autoComplete="new-password" @blur="checkPass(combinationSellForm.pass)"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="normal margin-t20" @click="onSubmit">{{redeemText}}</el-button>
      </el-form-item>
    </el-form>
    <!-- 成功页面 -->
    <section class="xDetail" v-show="stepDisplay == '2'">
      <div class="xDetail-icon">
        <img src="../../../assets/images/hbb/bigRight_230210309.png" width="40" alt="">
      </div>
      <p class="xDetail-title gColor">申请已受理</p>
      <!-- 进度 -->
      <ul class="xDetail-stepsone">
        <li class="xDetail-stepsone-li">
          <div class="xDetail-stepsone-li-head">
            <img src="../../../assets/images/time.png" alt="" width="20">
            <div class="xDetail-stepsone-li-head-shu"></div>
          </div>
          <div class="xDetail-stepsone-li-main">{{'预计'+time.expectcfmdate+'日'+time.expectcfmworkday+'24：00点前确认金额'}}</div>
        </li>
        <li class="xDetail-stepsone-li">
          <div class="xDetail-stepsone-li-head">
            <img src="../../../assets/images/20210316_sy.png" alt="" width="20">
          </div>
          <div class="xDetail-stepsone-li-main">{{'预计'+time.expect2acctdate+'日'+time.expect2acctworkday+'金额到账'}}</div>
        </li>

      </ul>
      <hr class="xDetail-hr">
      <ul class="xDetail-ul">
        <li class="xDetail-ul-li"><span>订单编号：</span><span>{{successMessage.combuyappsheetno}}</span></li>
        <li class="xDetail-ul-li"><span>组合名称：</span><span>{{this.$commonJs.getCombinationNameByCode(successMessage.combinationcode)}}</span></li>
      </ul>
      <hr class="xDetail-hr">
      <div class="xDetail-footer">
        <el-button type="normal" @click="returnClick">确定</el-button>
      </div>
    </section>
    <!-- 失败页面 -->
    <section class="xDetail" v-show="stepDisplay == '3'">
      <div class="xDetail-icon">
        <img src="../../../assets/images/hbb/error_20210309.png" width="40" alt="">
      </div>
      <p class="xDetail-title rColor">赎回失败</p>
      <hr class="xDetail-hr">
      <ul class="xDetail-ul">
        <li class="xDetail-ul-li"><span>失败原因：</span><span>{{wrongReason}}</span></li>
      </ul>
      <hr class="xDetail-hr">
      <div class="xDetail-footer">
        <el-button type="normal" @click="returnClick">确定</el-button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      redeemText: '确认赎回',
      errorMsg: '',
      stepDisplay: '1',
      combinationSellForm: {
        card: '',
        pass: ''
      },
      tcombinationSellFormRules: {
        card: [
          { required: true, message: '请选择银行卡', trigger: 'change' },
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ]
      },
      message: '',
      comfundlist: '',
      tanolist: '',
      comsharelist: '',
      // 
      wrongReason: '',
      successMessage: '',
      time: '',
    }
  },
  created () {
    this.message = this.$route.params.message
    // console.log(this.message);
    this.message.children.forEach(item => {
      this.comfundlist += item.fundcode + ','//基金代码
      this.tanolist += item.tano + ','//基金代码
      this.comsharelist += item.fundvol + ','//基金份额
    });
    // console.log(this.comfundlist.slice(0, -1));
  },
  methods: {
    returnClick () {
      this.$router.push({
        name: 'myAssets'
      })
    },
    checkPass () {

    },
    getslectedValue (val) {
      this.combinationSellForm.card = val
    },
    slectedValue (val) {
      window.sessionStorage.setItem('card', val)
      this.combinationSellForm.card = val

    },
    // 确认赎回
    onSubmit () {
      this.$refs.tcombinationSellFormRef.validate(valid => {
        if (!valid) return
        this.redeemText = '赎回中...'
        this.$http.post(this.$apiPath.batSellFund, {
          sessionId: this.$commonJs.getCookie('sessionid'),
          combinationcode: this.message.combinationcode,//
          transactorcerttype: '',
          comfundlist: this.comfundlist.slice(0, -1),//组合中的基金代码组成的字符串
          originappsheetserialno: '',
          transactionaccountid: this.message.transactionaccountid,//
          comsharelist: this.comsharelist.slice(0, -1),//赎回份额,隔开
          tanolist: this.tanolist.slice(0, -1),//ta代码,隔开
          branchcode: '308',
          transactorname: '',
          funddesc: this.message.funddesc,//
          sharetype: '',
          vastredeemflag: 0,
          transactorcertno: '',
          passwd: this.$des.enString(this.combinationSellForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),//
          moneyaccount: this.message.moneyaccount,//
          applicationamount: ''
        }).then(res => {
          // console.log(res);
          if (res.status !== 200) return
          if (res.data.code == "10000005") {
            // 密码输入错误
            this.errorMsg = res.data.message
            this.redeemText = '确认赎回'
          } else if (res.data.code == "9999") {
            // 操作频繁
            this.errorMsg = res.data.message
            this.redeemText = '确认赎回'
          } else if (res.data.code == "2004") {
            // 假期暂停
            this.$message.success(res.data.message)
            // this.errorMsg = res.data.message
            this.redeemText = '确认赎回'
          } else if (res.data.code == "200") {
            this.successMessage = res.data.data
            if (res.data.data.code == "0000") {
              this.stepDisplay = '2'
              this.getTime(this.successMessage.combuyappsheetno)
              // 推送消息
              this.$store.dispatch({
                type: "pushNews",
                index: 22,
                fundname: this.message.funddesc,
                money: "",
                dtDate: "",
                fundname2: ""
              })
            } else {
              this.wrongReason = '赎回失败'
              this.stepDisplay = '3'
            }
          } else {
            this.wrongReason = '赎回失败'
            this.stepDisplay = '3'
          }

        }).catch(err => { })
      })
    },
    // 日期进度
    getTime (combuyappsheetno) {
      this.$http.post(this.$apiPath.getGroupResult, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        combuyappsheetno: combuyappsheetno
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        if (result[0] && result[0][0]) {
          this.time = result[0][0]
        }
        // console.log(res);
      }).catch(err => { })
    }
  }
}
</script>

<style lang="less" scoped>
</style>